import { Dict, AddressResponse } from 'shared/interface/globalInterface';
import { Nullable } from 'utils/types';

export interface IDirector {
  id: string;
  title: string;
  firstName: string;
  middleName: string;
  surname: string;
  gender: string;
  dateOfBirth: Date | string;
  addresses: Address[];
}

export interface Address {
  id: string;
  postCode: string;
  houseNr: string;
  addressLine1: string;
  addressLine2: string;
  town: string;
  county: string;
  residentFrom: Date | string;
}

export interface RegisterFirmData1 {
  firstName: string;
  surname: string;
  email: string;
  firmName: string;
  fcaNumber: string | number;
  agreed: boolean;
  additionalPermissions: string;
}

export interface RegisterFirmData2 extends Dict {
  postCode: string;
  houseNr: string;
  addressLine1?: string;
  addressLine2?: string;
  companyEmail: string;
  companyTelephone: string;
  inNetwork?: 'true' | 'false' | null;
  sortCode?: string;
  accNo?: string;
  accountName?: string;
  nameOfBank?: string;
  networkFCA?: Nullable<string>;
}

export interface RegisterFirmData3 {
  directors: IDirector[];
}

export interface RegisterFirmData4 {
  introducerAgreement: boolean;
  privacyPolicy: boolean;
  dataProtectionPolicy: boolean;
  consentFromDirectors: boolean;
  inNetwork: 'true' | 'false' | null;
}

interface RegisterFirmCommonProps {
  handleSubmit: (values: any) => void;
  error?: string;
}

export interface Club {
  id: number;
  name: string;
}

export interface Term {
  companyName: string;
  fcaNumber: number;
  commissionTermsHeader: string;
  commissionPercentage: string;
}

export interface RegisterFirm1Props extends RegisterFirmCommonProps {
  formData: RegisterFirmData1;
}

interface LabelAndValue {
  label: string;
  value: string;
}

export interface RegisterFirm2Props extends RegisterFirmCommonProps {
  goBack: (values: RegisterFirmData2) => void;
  formData: RegisterFirmData2;
  clubOptions: Club[];
  addNetworkData: (data: any) => void;
  networkInfo: LabelAndValue[];
}

export interface RegisterFirm3Props extends RegisterFirmCommonProps {
  goBack: (values: RegisterFirmData3) => void;
  formData: RegisterFirmData3;
  genders: string[];
  titles: string[];
}

export interface RegisterFirm4Props extends RegisterFirmCommonProps {
  goBack: (values: RegisterFirmData4) => void;
  formData: RegisterFirmData4;
}

export interface RegisterSuccessProps {
  goBack: () => void;
}

export interface Radio {
  label: string;
  value: boolean | string;
}

export interface DirectorProps {
  genders: string[];
  titles: string[];
  directorsLength: number;
  arrayHelpers: any;
  directorIndex: number;
  directorPrefix: string;
  addresses: Address[];
}

export interface DirectorAddressProps {
  addressPrefix: string;
  addressIndex: number;
  onDateChange: (value: string) => void;
}

export interface NetworkInfoProps {
  networkInfo: LabelAndValue[];
}

export interface NetworkResponse extends AddressResponse {
  fca_number: string;
  is_registered: boolean;
  name: string;
}

export enum RegisterFirmHelpTexts {
  additionalPermissions = 'As a Firm Manager you will be able to review your own profile as well as the details of your firm. If you also require the ability to submit applications as an Adviser or on behalf of an Adviser please confirm below.',
}
